var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isContainer(),attrs:{"id":"app"}},[(_vm.isHideHeader() && _vm.isAdminWeddbetsHeader())?_c('HeaderAdminWeddbets'):(_vm.isHideHeader() && _vm.isNovoLayoutCliente())?_c('ClienteHeader'):(_vm.isHideHeader())?_c('Header'):_vm._e(),_c('div',{class:{
      adminHeaderConteudo:
        _vm.isHideHeader() && _vm.isAdminWeddbetsHeader(),
      clienteHeaderConteudo:
        _vm.isHideHeader() && _vm.isNovoLayoutCliente(),
    }},[_c('router-view')],1),_c('div',{staticClass:"notification-container"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }